export class AlternateTransportationQueryParameters {
  id?: string;
  addressLine?: string;
  appointmentId?: string;
  contactType?: string;
  countyId?: string;
  embed?: string[] = [];
  phone?: string;
  page?: number;
  pageSize?: number;
  pickUpDropOff?: string;
  placeId?: string;
  postalZipCode?: string;
  sequence?: string;
  transportOptionId?: string;

  constructor(obj?: AlternateTransportationQueryParameters) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}
